import moment from "moment";
import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const NotificationPopup = ({ selectedNotification, onClose }) => {
  return (
    <Modal isOpen={Boolean(selectedNotification)} toggle={onClose} centered>
      <div className="position-relative">
        <ModalHeader tag="div" className="border-bottom-0 pb-0">
          <h5 className="mb-0">Notification</h5>
        </ModalHeader>

        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="btn-close position-absolute"
          style={{ top: "16px", right: "16px" }}
        ></button>
      </div>

      <ModalBody>
        <p className="mb-2">{selectedNotification?.message}</p>
        <p className="mb-3 text-muted fs-12">
          <i className="mdi mdi-clock-outline"></i>{" "}
          {selectedNotification?.createdAt
            ? moment(selectedNotification.createdAt).fromNow()
            : ""}
        </p>

        <div className="text-end">
          <button type="button" onClick={onClose} className="btn btn-secondary">
            Close
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default NotificationPopup;